import { differenceInMinutes, setHours, format } from "date-fns";
import { Fragment, useMemo } from "react";
import { BORDER_HEIGHT } from "../helpers/constansts";
import Break from "./Break";

const TodayBreaks = (props) => {
  const {
    todayBreaks,
    today,
    startHour,
    step,
    minuteHeight,
    selectedDock,
    whMetaDocksList,
    dockList,
    showScheduleModal,
    setShowScheduleModal,
  } = props;

  const shouldShowBreakForDay = (segment, dayOfWeek) => {
    if (segment.dockId === "0000") {
      return false;
    }
    // Check break's operational days directly
    return segment[dayOfWeek] === true;
  };

  const dockColorMap = useMemo(() => {
    const map = {};
    dockList?.forEach(dock => {
      map[dock.dockId] = dock.dockColor;
    });
    return map;
  }, [dockList]);

  const dockNameMap = useMemo(() => {
    const map = {};
    dockList?.forEach(dock => {
      map[dock.dockId] = dock.dockName;
    });
    return map;
  }, [dockList]);

  return (
    <Fragment>
      {todayBreaks && todayBreaks.map((breakGroup, i) => {

        const height = differenceInMinutes(breakGroup.end, breakGroup.start) * minuteHeight - BORDER_HEIGHT;
        const minutesFromTop = differenceInMinutes(breakGroup.start, setHours(today, startHour));
        const top = minutesFromTop * minuteHeight;

        const dayNames = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
        const dayOfWeek = dayNames[today.getDay()];

        // Pass all segments to Break component
        const breakData = {
          start: breakGroup.start,
          end: breakGroup.end,
          segments: breakGroup.segments
        };

        return (
          <div
            key={i}
            style={{
              height: height + (height / 60) * BORDER_HEIGHT,
              top: top,
              left: "0%",
              width: "100%",
              zIndex: "85",
              position: "absolute",
            }}
          >
            <Break
              data={breakData}
              minuteHeight={minuteHeight}
              top={0}
              step={step}
              showScheduleModal={showScheduleModal}
              setShowScheduleModal={setShowScheduleModal}
              left={0}
              dayOfWeek={dayOfWeek}
              selectedDock={selectedDock}
              whMetaDocksList={whMetaDocksList}
              dockColorMap={dockColorMap}
              dockNameMap={dockNameMap}
            />
          </div>
        );
      })}
    </Fragment>
  );
};

export default TodayBreaks;
